(function() {
  // --- Keep the sticky cart's Loox rating scoped to the current product ---
  function formatStickyCartReviews() {
    const reviewContainer = document.querySelector('.satcb_reviews_stars');
    if (!reviewContainer) return;

    // The sticky-cart app sometimes leaves its rating container empty even after
    // Loox has rendered a valid rating beside the current product. Mirror that
    // current-product rating into the bar; never source it from recommendation cards.
    let hasRatingContent = Boolean(reviewContainer.querySelector('.loox-rating-content'));
    const productRatingContent = document.querySelector('.product--outer .loox-rating-content');

    if (!hasRatingContent && productRatingContent) {
      const stickyRating = document.createElement('div');
      stickyRating.className = 'loox-rating satcb-loox-rating';
      stickyRating.appendChild(productRatingContent.cloneNode(true));
      reviewContainer.replaceChildren(stickyRating);
      hasRatingContent = true;
    }

    // When the current product has no reviews, the sticky-cart app can fall back to
    // every Loox star SVG on the page (including related-product cards). Those
    // incorrect stars are direct children; a real product rating is wrapped in
    // .loox-rating-content.
    const hasDirectStars = Array.from(reviewContainer.children)
      .some((child) => child.matches('svg.loox-icon'));

    if (hasDirectStars && !hasRatingContent) {
      reviewContainer.replaceChildren();
      reviewContainer.style.setProperty('display', 'none', 'important');
      reviewContainer.dataset.looxInvalidFallback = 'true';
      return;
    }

    if (!hasRatingContent) return;

    // Restore the container now that a genuine current-product rating is present,
    // then wrap just the count so CSS can hide it on mobile.
    reviewContainer.style.removeProperty('display');
    delete reviewContainer.dataset.looxInvalidFallback;

    const ratingLabel = reviewContainer.querySelector('.loox-rating-label');
    if (!ratingLabel || ratingLabel.querySelector('.satcb-review-count')) return;

    const labelText = ratingLabel.textContent.replace(/\u00a0/g, ' ').trim();
    const labelParts = labelText.match(/^(.+?)\s*(\([^)]*\))$/);
    if (labelParts) {
      const count = document.createElement('span');
      count.className = 'satcb-review-count';
      count.textContent = ` ${labelParts[2]}`;
      ratingLabel.replaceChildren(
        document.createTextNode(`\u00a0${labelParts[1].trim()}`),
        count
      );
    }
  }

  // --- Currency setup ---
  const removableSuffixes   = ['AUD','CAD','NZD','EUR','GBP','USD'];
  const suffixToPrefixMap   = { AUD:'A$', CAD:'CA$', NZD:'NZ$', USD:'$', EUR:'€', GBP:'£' };
  const containersSelector = [
    '.price__current', '.satcb_price', '.satcb_was_price', '.cart-item--sale-price',
    '.atc-subtotal--price', '.atc--product-details--price-value',
    '.cart-item--content-price', '.cart-item__total',
    '.cart-subtotal', '.atc-banner--cart-subtotal',
    '.cart-title-total--small',
    '.cart-complementary__price-row',
    '.options-selection__swatch-card-price',
    '.voucher-amount',
    '.complementary-product__price'
  ].join(',');
  // Also used by variant updates: prepare the final markup before attaching it.
  function getFormattedPriceHTML(raw) {
    let cleaned = raw.trim();
    let overrideCur = null;
    const suffix = cleaned.match(/([\d.,]+)\s*([A-Z]{3})$/);
    if (suffix && removableSuffixes.includes(suffix[2])) {
      cleaned = cleaned.replace(/\s*[A-Z]{3}$/, '');
      overrideCur = suffixToPrefixMap[suffix[2]];
    }
    const match = cleaned.match(/^(CA\$|NZ\$|A\$|\$|€|£)/);
    const symbol = overrideCur || (match && match[1]);
    if (!symbol) return null;
    const tokens = cleaned.replace(/^(CA\$|NZ\$|A\$|\$|€|£)/, '').match(/(?:\d{1,3}(?:[., ]\d{3})+|\d+)(?:[.,]\d{1,2})?/g);
    if (!tokens) return null;
    let number = tokens[tokens.length - 1].replace(/\s/g, '');
    number = number.lastIndexOf(',') === number.length - 3
      ? number.replace(/\./g, '').replace(',', '.') : number.replace(/,/g, '');
    const amount = number.match(/^(\d+)\.(\d{2})$/);
    if (!amount) return null;
    return `<span class="satcb_price_inner" data-shopsta-price><span class="price-symbol">${symbol}</span><span class="price-whole">${amount[1]}</span><span class="shopsta-price-decimal">.</span><span class="price-fraction">${amount[2]}</span></span>`;
  }

  window.ShopstaPrices = {
    html(raw) {
      const source = document.createElement('span');
      source.innerHTML = raw;
      return getFormattedPriceHTML(source.textContent) || raw;
    }
  };

  function formatPrices() {
    document.querySelectorAll(containersSelector).forEach(container => {
      let els = container.querySelectorAll('.money');
      if (!els.length && (container.classList.contains('money') || container.classList.contains('voucher-amount'))) els = [container];
      els.forEach(el => {
        if (el.querySelector('.satcb_price_inner')) return;
        let prefix = '';
        const prev = el.previousElementSibling;
        if (prev && prev.classList.contains('money') && !prev.querySelector('.satcb_price_inner') && ['CA', 'NZ', 'A'].includes(prev.textContent.trim())) {
          prefix = prev.textContent.trim();
          prev.remove();
        }
        const html = getFormattedPriceHTML(prefix + el.textContent.trim());
        if (!html) return;
        el.innerHTML = html;
        if (el.closest('.satcb_price, .satcb_was_price')) el.style.visibility = 'visible';
      });
    });
  }

  // --- Function to run all dynamic updates ---
  function handleDOMChanges() {
    formatStickyCartReviews();
    formatPrices();
  }

  // --- initial + dynamic ---
  function initialize() {
  handleDOMChanges();
  const relevantSelector = `${containersSelector}, .money, .satcb_reviews_stars, .loox-rating-content`;
  new MutationObserver(mutations => {
    const relevant = mutations.some(mutation => {
      const target = mutation.target.nodeType === Node.ELEMENT_NODE
        ? mutation.target
        : mutation.target.parentElement;
      if (target && target.closest(relevantSelector)) return true;
      return Array.from(mutation.addedNodes).some(node =>
        node.nodeType === Node.ELEMENT_NODE &&
        (node.matches(relevantSelector) || node.querySelector(relevantSelector))
      );
    });
    // MutationObserver batches writes in a microtask, before the next paint.
    // Do not defer to an animation frame: that can expose an app's plain price.
    if (relevant) handleDOMChanges();
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
